import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from '../../api.service';
import { DfnDjlFlowComponent } from '../dfn-djl-flow/dfn-djl-flow.component';
import { SmpConnectivityN2pComponent } from '../smp-connectivity-n2p/smp-connectivity-n2p.component';
import { JlStructureComponent } from '../../components/common/jl-structure/jl-structure.component';
import { SelectBjlN2pComponent } from '../select-bjl-n2p/select-bjl-n2p.component';
import { UploadFileComponent } from '../../components/common/upload-file/upload-file.component';
import { SelectSmpN2pComponent } from '../select-smp-n2p/select-smp-n2p.component';
import { TableComponent } from '../../components/common/table/table.component';
import { MapN2pComponent } from '../map-n2p/map-n2p.component';
import { N2pUpstreamEquipmentComponent } from '../n2p-upstream-equipment/n2p-upstream-equipment.component';
import { FinalPageN2pComponent } from '../final-page-n2p/final-page-n2p.component';

@Component({
  selector: 'app-landing-page-n2p',
  standalone: true,
  imports: [ReactiveFormsModule,
    CommonModule,
    NgxSpinnerModule,
    DfnDjlFlowComponent,
    SmpConnectivityN2pComponent,
    JlStructureComponent,N2pUpstreamEquipmentComponent,
      SelectBjlN2pComponent,TableComponent,MapN2pComponent,
    UploadFileComponent,SelectSmpN2pComponent,FinalPageN2pComponent
  ],
  templateUrl: './landing-page-n2p.component.html',
  styleUrl: './landing-page-n2p.component.scss'
})
export class LandingPageN2pComponent {
  islogin: boolean = true;
  myForm!: FormGroup;
  showDFNCard: boolean = false;
  showDFLFields: boolean = false;
  showDFLFieldsDFN: boolean = true;
  showLFNSubmit: boolean = false;
  showMainPage: boolean = true;
  isLoading: boolean = false;
  query: string = '';
  success_path: boolean = false;
  showTable: boolean = false;
  tableData: any;
  showMDUCard: boolean = false;
  mduPayLoad: any;
  showADRCard: boolean = false;
  adrPayLoad: any;
  showEquipmetCard: boolean = false;
  equPayLoad: any;
  showMessage: boolean = false;
  MessageToShow: any;
  upstream_screen: boolean = false;
  showEndEquipment: boolean = false;
  smp_connectivity_flag: boolean = false;
  bjl_structure_flag: boolean = false;
  bjl_flag: boolean = false;
  flowName: string = 'LOC ID';
  file: string | null = null; 
  default: string = 'Type2';
  architectureOptions: string[] = ['Type2', 'Type3'];
  final_screen:boolean=false;
  data_flag:boolean = false;
  
  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private toastr: ToastrService,
    private apiService: ApiService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) {
    this.myForm = this.fb.group({
      ufaCategory: ['', Validators.required],
      type_program:['',Validators.required],
      //architectureType: ['', Validators.required],
      //rorId: ['', Validators.required],
      //locId: ['', Validators.required],
      adaId: ['', Validators.required],
      workType: ['', Validators.required],
      //  mps_boundary: [''],
      //locId: [''],
      //dwelling_type:['',Validators.required]
    });

    
  }


  ngOnInit() {
    
  }

    fileUploaded(event: string) {
    this.file = event;
    }
    
  onSubmit() {
    // onsubmit check if request is for LFN or DFN
    if (this.myForm.value.workType == 'DFN') {
      this.showDFNCard = true;
      this.showMainPage = false;
    } else {
      this.callCreateMapInfo();
    }
  }

  callCreateMapInfo() {
    // callCreateMapInfo call the api and based on api response initiate next flow like MDU, Equipment, etc. .
    this.isLoading = true;
    this.spinner.show();

    this.apiService.initiatemapinfodesignN2P(this.query).subscribe({
      next: (response) => {
        if (response.message === 'select existing smp') {
          this.smp_connectivity_flag = true;
          this.showMainPage = false;
          this.tableData = response;
        } else if (response.message === 'select bjl n2p') {
          this.showMainPage = false;
          this.tableData = response;
          this.bjl_flag = true;
        } else if (response.message === 'select upstream equipment n2p') {          
          this.tableData = response;
          this.bjl_flag = false;
          this.showMainPage = false;
          this.bjl_structure_flag = true;
          if ('error_messgae' in response) {
                this.toastr.error(
                    response.error_messgae,
                  'Error Message'
                );
              }
        }
        else if(response.message === 'n2p process completed'){
            this.bjl_flag = false;
            this.showMainPage = false;
            this.tableData = response;
            this.final_screen = true;
        }
        else {
          if ('file_name' in response) {
            this.showMessage = true;
            this.MessageToShow = response;
          } else {
            this.toastr.error(response.message, 'Error Message');
            console.log('error');
          }
        }
        this.isLoading = false;
        this.spinner.hide();
        
      },
      error: (error) => {
        this.isLoading = false;
        this.spinner.hide();
        this.toastr.error(
          `The API returned Unsuccessfull response : ${error}`,
          'Error Message'
        );
      },
    });
  }

  radioSelect() {
    // Based on radio button enable and disable Architecture Type dropdown type2 value
    console.log('radioSelect');
    if (this.myForm.value.workType == 'DFN') {
      this.showDFNCard = true;
      this.showLFNSubmit = false;
      // this.selectedProperty = this.options[1];
      this.myForm.controls['architectureType'].setValue('Type3');
      this.myForm.controls['architectureType'].disable({ onlySelf: true });
    }
    else {
      this.showDFNCard = false;
      this.showLFNSubmit = true;
      this.myForm.value.architectureType = '';
      this.myForm.controls['architectureType'].setValue('');
      this.myForm.controls['architectureType'].enable({ onlySelf: true });
    }
  }

  disableMainForm() {
    // Disable main form page from DFN flow
    this.showMainPage = false;
  }

  downloadFile() {
    // Path to the file in the assets folder
    const fileUrl = 'assets/sample_file/ada_Location.xlsx';

    // Create an invisible anchor element
    const anchor = document.createElement('a');
    anchor.href = fileUrl;
    anchor.download = 'ADA_Location.xlsx'; // Set the file name for the download

    // Trigger a click event on the anchor to start the download
    anchor.click();
  }

  callSheetValidate()
  {

    this.isLoading = true
    this.spinner.show();
    this.query = `?ufa_category=${this.myForm.value.ufaCategory}&ada_id=${this.myForm.value.adaId}&type_program=${this.myForm.value.type_program}&loc_id_file=${this.file}`;
    //this.query += `&s18_path=C:\\Users\\s.manohar.indulkar\\Downloads\\5BRR-01-13\\5BRR-01-13`
    this.isLoading = true;  
    this.spinner.show();
 
    this.apiService.sheet_validation(this.query, {responseType: 'blob' as 'json' }).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        this.spinner.hide();

        // Check if the response is a JSON (no errors)
        const reader = new FileReader();
        reader.onload = () => {
          try {
            const text = reader.result as string;
            const json = JSON.parse(text);

            // If parsing succeeds, it is JSON response
            if (json.message === 'Sheet-Validation Successfully done') {
              this.toastr.success(json.message, 'Success Message');
              this.data_flag = false;
            } 
            else 
            {
                if ('file_name' in response) {
                  this.showMessage = true;
                  this.MessageToShow = response;
                } 
                else 
                {
                  this.toastr.error(response.message, 'S18 File doesnt exist in s3 bucket');
                  console.log('error');
                }
              } 
          }catch (err) {
            // If JSON.parse fails, it's a CSV blob
            const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'error_report.csv';
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            this.toastr.error('Validation errors found. CSV downloaded.', 'Error Message');
            this.data_flag = true;
          }
        };
        reader.readAsText(response);
      },
      error: (err) => {
        this.isLoading = false;
        this.spinner.hide();
        this.toastr.error('Something went wrong!', 'Error Message');
      }
    });
    
  }

  OnSelectProceedMap(data: any) { }
  receiveTableEventStructure(data: any) { }
  
  receiveTableEventUpstream(data:any){}
}
